import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const objections = [{
  question: 'He intentado de todo.',
  answer: "Perfecto. Aquí no vienes a intentar. Vienes a ejecutar 5 minutos. El método está diseñado para funcionar incluso cuando ya has probado todo lo demás porque elimina la fricción de la 'gran meta'."
}, {
  question: 'Yo soy inconstante.',
  answer: 'No. Tú has practicado inconstancia. Y lo que se practica, se puede reentrenar. La identidad no es fija, es un hábito repetido.'
}, {
  question: 'No tengo tiempo.',
  answer: "Entonces este producto es exactamente para ti. Tu primera meta no es 'cambiar tu vida'. Es no hacer cero. Si no tienes 5 minutos, no tienes vida."
}, {
  question: '¿Y si fallo?',
  answer: 'Vas a fallar algún día. La diferencia es que aquí no se abandona: se reinicia. Te enseñamos el protocolo exacto para volver al camino sin culpa.'
}];
export function ObjectionsSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 md:py-32 bg-[#0a1628] relative" data-id="element-137">
      <div className="max-w-3xl mx-auto px-6" data-id="element-138">
        <FadeIn data-id="element-139">
          <h2 className="text-3xl md:text-5xl text-white text-center mb-16" data-id="element-140">
            Objeciones típicas{' '}
            <span className="text-[#64748b] block text-2xl mt-2 font-sans font-normal" data-id="element-141">
              (y respuesta honesta)
            </span>
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-142">
          {objections.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-143">
              <div className={`border rounded-lg overflow-hidden transition-colors duration-300 ${openIndex === index ? 'border-[#d4af37] bg-[#1e3a5f]/20' : 'border-[#1e3a5f] bg-transparent'}`} data-id="element-144">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-145">
                  <span className={`text-xl font-medium ${openIndex === index ? 'text-[#d4af37]' : 'text-white'}`} data-id="element-146">
                    {item.question}
                  </span>
                  {openIndex === index ? <Minus className="text-[#d4af37]" data-id="element-147" /> : <Plus className="text-gray-400" data-id="element-148" />}
                </button>
                <AnimatePresence data-id="element-149">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-150">
                      <div className="p-6 pt-0 text-gray-300 leading-relaxed border-t border-[#1e3a5f]/50 mt-2" data-id="element-151">
                        {item.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}